import { provider } from "../../providers";
import { IStatistic } from '@grassrootly/api/entities/IStatistic';

export interface GetMonthlyStatsPayload {
  playerId?: number;
  month: number;
  year: number;
}

export const GetMonthlyStats = async (params: GetMonthlyStatsPayload): Promise<IStatistic> =>
  provider.Request("/stats", params);
